import React from "react";
import StatisticsComponent from "../../component/StatisticsComponent";
import { MdFactory } from "react-icons/md";
import { BsBriefcase, BsDatabase, BsPeople } from "react-icons/bs";
import Manufacturing from "../../assets/Images/manufacturing.jpg";

const Statistics = ({ statData }) => {
  return (
    <div>
      <section
        style={{ backgroundImage: `url(${Manufacturing})` }}
        className="min-h-80 my-20 bg-black backdrop-filter flex flex-wrap items-center justify-center bg-cover sm:px-20 px-5"
      >
        <div className="sm:w-full overflow-x-auto flex flex-wrap items-center justify-center h-full gap-16">
          <StatisticsComponent
            Logo={<MdFactory />}
            value={statData?.companies?.length}
            statisticTitle="Companies"
            duration="2000"
          />
          <StatisticsComponent
            Logo={<BsDatabase />}
            value={statData?.applications?.length}
            statisticTitle="Applications"
            duration="2000"
          />
          <StatisticsComponent
            Logo={<BsBriefcase />}
            value={statData?.jobs?.length}
            statisticTitle="Job posted"
            duration="2000"
          />
          <StatisticsComponent
            Logo={<BsPeople />}
            value={statData?.jobSeeker?.length}
            statisticTitle="Members"
            duration="2000"
          />
        </div>
      </section>
    </div>
  );
};

export default Statistics;
